import { render, staticRenderFns } from "./carillon-dangelus.vue?vue&type=template&id=54aff2d6&scoped=true"
import script from "./carillon-dangelus.vue?vue&type=script&lang=js"
export * from "./carillon-dangelus.vue?vue&type=script&lang=js"
import style0 from "./carillon-dangelus.vue?vue&type=style&index=0&id=54aff2d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aff2d6",
  null
  
)

export default component.exports